<template>
  <div class="tenant__add">
    <h3>Add Tenant</h3>
    <section>
      <form @submit.prevent="validateBeforeSubmit">
        <b-field>
          <b-input
            v-model="name"
            placeholder="Name"
            name="name"
            v-validate="'required|max:50'"
          />
        </b-field>
        <b-field label="Options" :addons="false">
          <b-switch
            v-model="isCollaboration"
            title="Allows none administrators to add spaces"
            name="collaboration"
            >Collaboration</b-switch
          >
          <b-switch
            v-model="isVisible"
            title="Is visible under pages"
            name="visible"
            >Visible</b-switch
          >
        </b-field>
        <b-field label="Add administrators (email)">
          <b-taginput
            v-model="administrators"
            ellipsis
            icon="label"
            placeholder="Add a administrator (email)"
            aria-close-label="Delete this administrator"
          >
          </b-taginput>
        </b-field>
        <div>
          <button
            type="submit"
            :disabled="!user"
            :title="!user ? 'Please login to add a tenant' : 'Add Tenant'"
            class="button is-success is-rounded action-button"
            icon-left="plus"
          >
            Add Tenant
          </button>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { generateValidUrlString } from "../../utils/helpers";

export default {
  name: "add",
  data: () => {
    return {
      name: "",
      isCollaboration: true,
      isVisible: true,
      administrators: [],
      password: null
    };
  },
  computed: {
    ...mapGetters(["user", "tenant"])
  },
  methods: {
    ...mapActions(["createTenant"]),
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$buefy.toast.open({
            message: "Form is valid!",
            type: "is-success",
            position: "is-top-right"
          });
          this.createTenant({
            name: this.name,
            tenantId: generateValidUrlString(this.name),
            collaboration: this.isCollaboration,
            visible: this.isVisible,
            administrators: this.administrators
          });

          return;
        }
        this.$buefy.toast.open({
          message: "Form is not valid! Please check the fields.",
          type: "is-danger",
          position: "is-top-right"
        });
      });
    }
  }
};
</script>
